/**
 *  CandyPowerup
 *
 *  Created by Legman on 06/06/2017.
 *
 */

import BombPowerup from "./BombPowerup";
import Candy from "./Candy";
import Common from "../Common";

/**
 * @class
 * @extends Powerup
 */
export default class CandyPowerup extends BombPowerup {
    /**
     * @param {RaceCar} collector
     */
    constructor(collector) {
        super(collector);
    }

    /**
     * @returns {Candy}
     * @private
     */
    _createBomb() {
        return new Candy(this._collector);
    }

    _playSound() {
        Common.audio.playSound("sfx_powerup_candy_00");
    }
}